// src/pages/Home.js
import React from 'react';

function Home() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">ホーム</h2>
      <p className="text-lg text-gray-700 mb-6">
        このアプリは、オフィススキルのポートフォリオを簡単に作成できるツールです。
      </p>
      <ul className="list-disc pl-6 space-y-2 text-gray-700">
        <li>スキルを登録して管理</li>
        <li>ポートフォリオをPDFで出力</li>
        <li>学習進捗を記録</li>
      </ul>
    </div>
  );
}

export default Home;
